import React, { useState } from "react";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import useStyles from "./styles";

export interface Props {
  children: React.ReactNode[];
  minToShow: number;
  maxToShow?: number;
  simpleList?: boolean;
}

const CollapsedList = (props: Props) => {
  const { children, minToShow, maxToShow, simpleList } = props;
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const items = children;

  const handleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <section className={classes.root}>
      <section className={classes.content}>
        {[...items].slice(0, minToShow)}
      </section>
      <Collapse in={simpleList || !collapsed} className={classes.content}>
        {[...items].slice(minToShow, maxToShow || items.length)}
      </Collapse>
      {items.length > minToShow && !simpleList && (
        <footer className={classes.footer} onClick={handleCollapse}>
          <span className={classes.footerButton}>
            <span className={classes.footerText}>
              {collapsed ? "View More" : "View Less"}
            </span>
            <ExpandMoreIcon
              className={clsx(classes.footerIcon, {
                [classes.footerIconCollapsed]: !collapsed
              })}
            />
          </span>
        </footer>
      )}
    </section>
  );
};

export default CollapsedList;
